import React from 'react';

const CircularLoader = ({ label = 'Loading...', size = 'md', className = '' }) => {
  const sizeClass =
    size === 'sm'
      ? 'h-6 w-6 border-2'
      : size === 'lg'
        ? 'h-12 w-12 border-4'
        : 'h-8 w-8 border-4';

  return (
    <div className={`flex flex-col items-center justify-center ${className}`.trim()}>
      <div className={`animate-spin rounded-full ${sizeClass} border-gray-200 border-t-orange-500`} />
      {!!label && <p className="mt-3 text-sm text-gray-600">{label}</p>}
    </div>
  );
};

export default CircularLoader;
